import React from 'react';
import type { ChatMessage } from './types';
import styles from './UserMessage.module.scss';

interface UserMessageProps {
  message: ChatMessage;
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export const UserMessage: React.FC<UserMessageProps> = ({ message }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bubble}>
        <div className={styles.text}>{message.content}</div>
      </div>
      <div className={styles.time}>{formatTime(message.timestamp)}</div>
    </div>
  );
};
